import { render, staticRenderFns } from "./ChecklistAnswerTotalItem.vue?vue&type=template&id=b3d9ec66&scoped=true"
import script from "./ChecklistAnswerTotalItem.vue?vue&type=script&lang=js"
export * from "./ChecklistAnswerTotalItem.vue?vue&type=script&lang=js"
import style0 from "./ChecklistAnswerTotalItem.vue?vue&type=style&index=0&id=b3d9ec66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d9ec66",
  null
  
)

export default component.exports